// Gom kết quả 4 nguồn của popup biểu đồ nhiên liệu, MỖI NGUỒN ĐỘC LẬP (chủ sở hữu: "Lỗi theo từng nguồn").
//
// dispatch(thunk) không bao giờ throw: request lỗi trả về action `.../rejected` mà `payload` là
// object lỗi (truthy). Phải kiểm tra rejected TRƯỚC khi đọc payload, nếu không object lỗi bị coi là
// một dòng dữ liệu và màn hình hiện số 0 đo được ("0.00 Km") thay vì "--".
//
// Bốn nguồn:
//   summary   report_api fuel summary      -> 6 chỉ số (Km, giờ nổ máy, định mức, tiêu hao, số lần
//                                              đổ, số lần hút) + 2 điểm biên (mức đầu/cuối, Km cuối)
//   fillDrain report_api fill/drain events -> các điểm sự kiện đổ/hút trên biểu đồ
//   positions core /devices/{id}/position -> chuỗi vận tốc, chuỗi Km (gốc odometer), mức dầu dự phòng
//   oil       core /devices/{id}/statistic/oil -> chuỗi mức dầu theo cảm biến
// Nguồn lỗi chỉ bị bỏ rỗng; các nguồn khỏe giữ nguyên dữ liệu như trước.
export const isRejectedAction = r =>
  !!r &&
  ((typeof r.type === 'string' && r.type.endsWith('/rejected')) ||
    r.meta?.requestStatus === 'rejected');

export const SOURCES = ['summary', 'fillDrain', 'positions', 'oil'];

const sourceStatus = res => (isRejectedAction(res) ? 'failed' : res ? 'ok' : 'skipped');

export function assembleChartData({ summaryRes, fillDrainRes, positionRes, oilRes }) {
  const results = { summary: summaryRes, fillDrain: fillDrainRes, positions: positionRes, oil: oilRes };
  const status = {};
  const failures = [];
  SOURCES.forEach(src => {
    status[src] = sourceStatus(results[src]);
    if (status[src] === 'failed') failures.push({ source: src, action: results[src] });
  });
  const okRes = src => (status[src] === 'failed' ? null : results[src]);

  const s = okRes('summary');
  let summaryData = [];
  if (s?.payload?.data) summaryData = s.payload.data;
  else if (Array.isArray(s?.payload)) summaryData = s.payload;
  else if (s?.payload && !Array.isArray(s.payload)) summaryData = [s.payload];

  const f = okRes('fillDrain');
  let fillDrainData = [];
  if (f?.payload?.data) fillDrainData = f.payload.data;
  else if (Array.isArray(f?.payload)) fillDrainData = f.payload;

  const positionData = okRes('positions')?.payload?.payload?.path || [];
  const oilData = okRes('oil')?.payload?.payload?.result || [];
  return { status, failures, summaryData, fillDrainData, positionData, oilData };
}

// Phần nào của màn hình phụ thuộc nguồn nào (đọc từ ActivityChartModal):
//   stats     = 6 chỉ số  <- summary (Km = điểm biên cuối = tổng totalKmGPS của summary)
//   summary   = điểm biên đầu/cuối (mức đầu/cuối, Km cuối) <- summary
//   positions = chuỗi vận tốc + chuỗi Km <- positions (Km tương đối so với điểm đầu của positions)
// fillDrain và oil lỗi: chỉ mất điểm của chính chúng, không chỉ số nào thành "0".
export function chartAvailability(status) {
  const summary = status.summary !== 'failed';
  const positions = status.positions !== 'failed';
  return { stats: summary, summary, positions };
}
